/*
 * Proprietary and Confidential
 *
 * Copyright (c) [2018] -  [] Marcelo H. Krebber - Munich, London 2018
 * All Rights Reserved.
 *
 * Dissemination or reproduction of this file [simple-landing-page.js] or parts within
 * via any medium is strictly forbidden unless prior written permission is obtained
 * from <marcelo.krebber@gmail.com>
 *
 * Last modified: 19.11.19, 17:25
 */

import React, {useRef} from 'react';
import {useIsMobile, useLanguage} from "../configuration/configuration";
import {useLocationCities} from "../../selectors";
import {PlyrVideoPlayer} from "../media-players/plyr-video-player";
import {useHistory} from "react-router-dom";
import {getLandingPageMediaUrl} from "../../actions/environment";

const DEFAULT_CITY = 'MUNICH';

// TODO load this media interactively
// temporary static setup to display thru nginx media server
const videoPathDesktop = 'salsaurbana-frau-mit-logo.mp4';
const coverPathDesktop = 'salsaurbana-frau-mit-logo.jpg';
const videoPathMobile = 'salsaurbana-frau-mit-logo-vertical.mp4';
const coverPathMobile = 'salsaurbana-frau-mit-logo-vertical.jpg';

const LandingPage = () => {
    const {LOCATION_CITIES, NAVIGATION_CITIES, locationCity} = useLocationCities();
    const history = useHistory();
    const isMobile = useIsMobile();
    const Lang = useLanguage();
    const [device] = React.useState(() => {
        return isMobile ? {
            videoUrl: getLandingPageMediaUrl(videoPathMobile),
            coverUrl: getLandingPageMediaUrl(coverPathMobile),
            ratio: 'ratio ratio-9x16',
            footer: 'footer-centered',
        } : {
            videoUrl: getLandingPageMediaUrl(videoPathDesktop),
            coverUrl: getLandingPageMediaUrl(coverPathDesktop),
            ratio: 'ratio ratio-16x9',
            footer: 'footer-right-aligned',
        }
    });
    const landingPlyrRef = useRef();
    const [selectedCity, setSelectedCity] = React.useState(locationCity(DEFAULT_CITY));

    const handleCityMainPage = (event) => {
        history.push(selectedCity.link);
    }

    const onCitySelection = (event) => {
        const key = event.target.dataset.cityKey;
        setSelectedCity(LOCATION_CITIES[key]);
    }

    const renderCitiesSelection = () => {
        const renderedCities = [];
        Object.keys(LOCATION_CITIES).forEach((key, index) => {
            const item = <li data-city-key={key} onClick={onCitySelection} className="dropdown-item">
                {locationCity(key).name}
            </li>
            renderedCities.push(item);
        });

        return <div className="btn-group dropup">
            <button className="btn btn-primary btn-lg" type="button" onClick={handleCityMainPage}>
                {selectedCity.name}
            </button>
            <button type="button" className="btn btn-lg btn-primary dropdown-toggle dropdown-toggle-split"
                    data-bs-toggle="dropdown" aria-expanded="false">
                <span className="visually-hidden">Select City</span>
            </button>
            <ul className="dropdown-menu dropdown-menu-dark">
                {renderedCities}
            </ul>
        </div>
    };

    const renderNavigationButton = (key, index) => {
        const city = NAVIGATION_CITIES[key];
        return <button className="btn btn-primary btn-lg" key={index} type="button"
                       data-city-key={key} onClick={handleNavigationPage}>
            {city.name}
        </button>
    }

    const handleNavigationPage = (event) => {
        const key = event.target.dataset.cityKey;
        const city = NAVIGATION_CITIES[key];
        history.push(city.link);
    }

    const renderNavigationButtons = () => {
        return Object.keys(NAVIGATION_CITIES).map((key, index) => {
            return renderNavigationButton(key, index);
        })
    }

    const renderTextAnimation = () => {
        return <div className={`${device.ratio} landing-page-text-overlay`}>
            <div>
                <div className='text-overlay-top'>
                    <div className='text-overlay-wrapper'>
                        <div className='overlay-text text-1'>{Lang.location.intro.baila}</div>
                        <div className='overlay-text text-2'>{Lang.location.intro.respira}</div>
                        <div className='overlay-text text-3'>{Lang.location.intro.repite}</div>
                    </div>
                </div>
            </div>
        </div>
    }

    return <div className="landing-page-container">
        {/*<BackgroundImage background={background}/>*/}

        <div className={device.ratio}>
            <PlyrVideoPlayer ref={landingPlyrRef} forceautoplay={true} loop={false}
                             source={{
                                 type: "video",
                                 sources: [{src: device.videoUrl, type: "video/mp4"}]
                             }}/>
        </div>

        {!isMobile && renderTextAnimation()}

        <div className={`${device.ratio} landing-page-navigation-overlay`}>
            <div>
                <div className={`navigation-overlay-footer ${device.footer}`}>
                    <div className="button-container">
                        {renderNavigationButtons()}
                        {renderCitiesSelection()}
                    </div>
                </div>
            </div>
        </div>
    </div>
}

export default LandingPage;